import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";
import { isInteractiveKeyCode } from "../../utils/helpers";

class BackButton extends Component {
  constructor(props) {
    super(props);
  }

  handleKeyUp(e) {
    if (isInteractiveKeyCode(e)) {
      this.props.handleBackButton(e);
      this.props.resetGridCalc(e);
    }
  }

  render() {
    return (
      <button 
        className={`btn ${this.props.classList}`} 
        onClick={(e) => {this.props.handleBackButton(e); this.props.resetGridCalc(e);} }
        onKeyUp={(e) => this.handleKeyUp(e)}
        tabIndex="0"
      >
        <FontAwesomeIcon icon={faLongArrowAltLeft} />
        {this.props.buttonText}
      </button>
    );
  }
}

export default BackButton;
